import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { TeamMember } from "@/types/team";
import { RemoveMemberDialog } from "./RemoveMemberDialog";
import { useAuth } from "@/hooks/useAuth";
import { canManageTeam } from "@/lib/permissions";

interface MemberActionsMenuProps {
  member: TeamMember;
}

export function MemberActionsMenu({ member }: MemberActionsMenuProps) {
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const { role } = useAuth();
  const hasManagePermission = canManageTeam(role);
  const isOwner = member.role === "owner";

  if (!hasManagePermission) {
    return null;
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setRemoveDialogOpen(true)}
        disabled={isOwner}
        title={isOwner ? "Owner cannot be removed" : "Remove member"}
      >
        Remove
      </Button>
      {!isOwner && (
        <RemoveMemberDialog
          memberId={member.id}
          email={member.email}
          open={removeDialogOpen}
          onOpenChange={setRemoveDialogOpen}
        />
      )}
    </>
  );
}
